
import React from "react";
import { ClientDetailWrapper } from "./ClientDetailWrapper";
import { Loader2 } from "lucide-react";

interface ClientDetailLoadingProps {
  avatarUrl: string;
  name: string;
}

export const ClientDetailLoading = ({ avatarUrl, name }: ClientDetailLoadingProps) => {
  return (
    <ClientDetailWrapper avatarUrl={avatarUrl} name={name}>
      <div className="flex-1 flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="h-8 w-8 text-white animate-spin" />
          <p className="text-white">Loading client data...</p>
        </div>
      </div>
    </ClientDetailWrapper>
  );
};
